const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/middleware/kisapi/timeout.ts';
/**
 * timeout middleware to be used with kisapi redux middleware
 */

import { Store } from 'redux';
import { GenericRequest } from '../genericMiddleware';

/**
 * this function races against the request sent to KisApi and sends a error response
 * back after a configurable time.
 * @param {Store} gets passed down from middleware and comes from redux framework
 * @param {IAsyncMiddlewareNext} contains function ref to the next transformatio step in the pipeline
 * @param {IKisApiRequest} the object from kisApi key of intercepted action
 * @return {Promise<Response>} http response object
 */
export default function timeout(ms: number) {
    return (_store: Store<any>) => (next: any) => async (action: GenericRequest) => {
        const timer = new Promise((resolve: any) => setTimeout(resolve, ms, 'expired'));
        let response = await Promise.race([next(action), timer]);
        if (response === 'expired') {
            // just necessary because typings of whatwg-fetch is doing not include constructor arguments
            const httpHeaders = new Headers();
            httpHeaders.append('content-type', 'application/json');
            response = new Response('{}', {
                headers: httpHeaders,
                status: 504,
                statusText: 'Response took to long',
            });
        }
        return response;
    };
}
